import request from '@/utils/request'

// 法币充值列表
export const getAntBuyTask = (params: any) => request({
  url: 'manage/ant-buy-task',
  method: 'get',
  params
})

// 审批事项接口
export const antBuyTask = (data: any) =>
  request({
    url: 'manage/ant-buy-task/' + data.id,
    method: 'put',
    data
  })

// 审批事项接口
export const antBuyExport = (data: any) =>
  request({
    url: 'manage/ant-buy-task/export',
    method: 'post',
    data
  })
